import { makeStyles, createStyles, Theme } from '@material-ui/core';
import Colors from '../Colors';

export const optionStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexFlow: 'column',
      marginTop: '1%',
      height: '90%',

    },
    modal: {
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalCharts:{
      display: 'block',
      height: '100%',

      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    button: {
      [theme.breakpoints.down('md')]: {
        width: "100%",
        alignSelf: 'flex-start',
        fontWeight: 'bold',
        fontSize: '14px',
        color: '#e8a300',
      },
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    buttonClose:{
      [theme.breakpoints.down('md')]: {
        width: "100%",
        alignSelf: 'flex-start',
        fontWeight: 'bold',
        fontSize: '14px',
        backgroundColor: Colors.secundary,
        color: '#404040',
      },
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
  }),
);
